import { BaseComponent, BElement } from "utils/base-component"
import throttle from "utils/throttle"
import "./index.scss"
import "./static/icon__arrow-head.svg"

const PAST_SCROLL_SLACK_PX = 8
const TABLE_CSS = "forecast-table"

export class HindcastPrompt extends BaseComponent {
  static cssClass = "hindcast-prompt"

  private nowButton!: BElement
  private tableContent!: BElement
  private firstCell!: BElement
  private nowOrigin!: number

  init() {
    const nowButton = this.element("now-button")
    if (!nowButton) {
      return
    }
    this.nowButton = nowButton

    const tableContentEl = document.querySelector(`.${TABLE_CSS}__content`)
    if (!tableContentEl) {
      return
    }
    this.tableContent = new BElement(tableContentEl, `${TABLE_CSS}__content`)

    const firstCellEl = this.tableContent.element.querySelector("[data-first-cell]")
    if (!firstCellEl) {
      return
    }
    this.firstCell = new BElement(firstCellEl, `${TABLE_CSS}__cell`)
    this.nowOrigin = this.firstCell.element.offsetLeft

    this.nowButton.element.addEventListener("click", (event) => {
      event.preventDefault()
      this.scrollToFirstCell()
    })

    const sync = throttle(() => this.syncNowButton(), 100)
    this.tableContent.element.addEventListener("scroll", sync, { passive: true })
    new MutationObserver(() => requestAnimationFrame(() => this.syncNowButton())).observe(
      this.tableContent.element,
      { childList: true, subtree: true },
    )
    this.syncNowButton()
  }

  private syncNowButton() {
    this.nowButton.toggleModifier("hidden", !this.isScrolledIntoPast())
  }

  private isScrolledIntoPast() {
    return (
      this.tableContent.element.scrollLeft + this.nowOrigin + PAST_SCROLL_SLACK_PX <
      this.firstCell.element.offsetLeft
    )
  }

  private scrollToFirstCell() {
    const left = this.firstCell.element.offsetLeft
    try {
      this.tableContent.element.scroll({ left, top: 0, behavior: "smooth" })
    } catch {
      this.tableContent.element.scrollLeft = left
    }
  }
}
